export const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_238_5932)">
        <path
          d="M8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.37827 15.1571 4.34344 13.6569 2.84315C12.1566 1.34285 10.1217 0.5 8 0.5C5.87827 0.5 3.84344 1.34285 2.34315 2.84315C0.842855 4.34344 0 6.37827 0 8.5C0 10.6217 0.842855 12.6566 2.34315 14.1569C3.84344 15.6571 5.87827 16.5 8 16.5ZM8 4.5C8.41562 4.5 8.75 4.83437 8.75 5.25V8.75C8.75 9.16562 8.41562 9.5 8 9.5C7.58437 9.5 7.25 9.16562 7.25 8.75V5.25C7.25 4.83437 7.58437 4.5 8 4.5ZM7 11.5C7 11.2348 7.10536 10.9804 7.29289 10.7929C7.48043 10.6054 7.73478 10.5 8 10.5C8.26522 10.5 8.51957 10.6054 8.70711 10.7929C8.89464 10.9804 9 11.2348 9 11.5C9 11.7652 8.89464 12.0196 8.70711 12.2071C8.51957 12.3946 8.26522 12.5 8 12.5C7.73478 12.5 7.48043 12.3946 7.29289 12.2071C7.10536 12.0196 7 11.7652 7 11.5Z"
          fill="#DC2626"
        />
      </g>
      <defs>
        <clipPath id="clip0_238_5932">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TryAgainIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M10.5631 4.87501H9.1877C8.70371 4.87501 8.3127 5.26603 8.3127 5.75001C8.3127 6.234 8.70371 6.62501 9.1877 6.62501H12.6877C13.1717 6.62501 13.5627 6.234 13.5627 5.75001V2.25001C13.5627 1.76603 13.1717 1.37501 12.6877 1.37501C12.2037 1.37501 11.8127 1.76603 11.8127 2.25001V3.65001L11.3314 3.16876C8.93887 0.776184 5.06152 0.776184 2.66895 3.16876C0.276367 5.56134 0.276367 9.43868 2.66895 11.8313C5.06152 14.2238 8.93887 14.2238 11.3314 11.8313C11.6732 11.4895 11.6732 10.9344 11.3314 10.5926C10.9896 10.2508 10.4346 10.2508 10.0928 10.5926C8.38379 12.3016 5.61387 12.3016 3.90488 10.5926C2.1959 8.88361 2.1959 6.11368 3.90488 4.4047C5.61387 2.69572 8.38379 2.69572 10.0928 4.4047L10.5631 4.87501Z"
        fill="#DC2626"
      />
    </svg>
  );
};

export const ReportBug = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g clipPath="url(#clip0_2843_2118)">
        <path
          d="M7 0.5C8.44922 0.5 9.625 1.67578 9.625 3.125V3.22344C9.625 3.65273 9.27773 4 8.84844 4H5.1543C4.725 4 4.37773 3.65273 4.37773 3.22344V3.125C4.37773 1.67578 5.55352 0.5 7.00273 0.5H7ZM1.13203 3.38203C1.47383 3.04023 2.02891 3.04023 2.3707 3.38203L4.1207 5.13203C4.13984 5.15117 4.15625 5.17031 4.17266 5.18945C4.56094 4.98984 5.00391 4.87773 5.47148 4.87773H8.53398C9.00156 4.87773 9.4418 4.98984 9.83281 5.18945C9.84922 5.17031 9.86563 5.15117 9.88477 5.13203L11.6348 3.38203C11.9766 3.04023 12.5316 3.04023 12.8734 3.38203C13.2152 3.72383 13.2152 4.27891 12.8734 4.6207L11.1234 6.3707C11.1043 6.38984 11.0852 6.40625 11.066 6.42266C11.2355 6.75078 11.3422 7.11445 11.3695 7.50273H13.1277C13.6117 7.50273 14.0027 7.89375 14.0027 8.37773C14.0027 8.86172 13.6117 9.25273 13.1277 9.25273H11.3777C11.3777 9.92539 11.2273 10.5598 10.9566 11.1285C11.0168 11.1641 11.0715 11.2078 11.1207 11.2598L12.8707 13.0098C13.2125 13.3516 13.2125 13.9066 12.8707 14.2484C12.5289 14.5902 11.9738 14.5902 11.632 14.2484L9.90664 12.523C9.23672 13.1191 8.38086 13.5129 7.4375 13.6059V7.0625C7.4375 6.82187 7.24063 6.625 7 6.625C6.75937 6.625 6.5625 6.82187 6.5625 7.0625V13.6031C5.61914 13.5102 4.76328 13.1164 4.09336 12.5203L2.36797 14.243C2.02617 14.5848 1.47109 14.5848 1.1293 14.243C0.7875 13.9012 0.7875 13.3461 1.1293 13.0043L2.8793 11.2543C2.93125 11.2023 2.98594 11.1613 3.04336 11.123C2.77539 10.557 2.625 9.92266 2.625 9.25H0.875C0.391016 9.25 0 8.85898 0 8.375C0 7.89102 0.391016 7.5 0.875 7.5H2.6332C2.66328 7.11445 2.76992 6.74805 2.93672 6.41992C2.91758 6.40352 2.89844 6.38711 2.8793 6.36797L1.1293 4.61797C0.7875 4.27617 0.7875 3.72109 1.1293 3.3793L1.13203 3.38203Z"
          fill="#94A3B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2843_2118">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AssistantErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_1191_3420)">
        <path
          d="M7.99982 1.5C8.44357 1.5 8.85295 1.73437 9.07795 2.11875L15.8279 13.6187C16.0561 14.0062 16.0561 14.4844 15.8342 14.8719C15.6123 15.2594 15.1967 15.5 14.7498 15.5H1.24982C0.802948 15.5 0.387323 15.2594 0.165448 14.8719C-0.0564269 14.4844 -0.0533019 14.0031 0.171698 13.6187L6.9217 2.11875C7.1467 1.73437 7.55607 1.5 7.99982 1.5ZM7.99982 5.5C7.5842 5.5 7.24982 5.83437 7.24982 6.25V9.75C7.24982 10.1656 7.5842 10.5 7.99982 10.5C8.41545 10.5 8.74982 10.1656 8.74982 9.75V6.25C8.74982 5.83437 8.41545 5.5 7.99982 5.5ZM8.99982 12.5C8.99982 12.2348 8.89447 11.9804 8.70693 11.7929C8.51939 11.6054 8.26504 11.5 7.99982 11.5C7.73461 11.5 7.48025 11.6054 7.29272 11.7929C7.10518 11.9804 6.99982 12.2348 6.99982 12.5C6.99982 12.7652 7.10518 13.0196 7.29272 13.2071C7.48025 13.3946 7.73461 13.5 7.99982 13.5C8.26504 13.5 8.51939 13.3946 8.70693 13.2071C8.89447 13.0196 8.99982 12.7652 8.99982 12.5Z"
          fill="#2563EB"
        />
      </g>
      <defs>
        <clipPath id="clip0_1191_3420">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
